import { getDateAndTimeFromDateTime, checkIsPastSectionUnlockDateTime } from 'screens/SectionEditorModal/utils';
export function checkIsSectionLockedForPreview(isPreviewMode, section) {
  var lockingMode = section.lockingMode,
    unlockDateTime = section.unlockDateTime,
    unlockTimezone = section.unlockTimezone;
  if (!isPreviewMode || !lockingMode) return false;
  if (lockingMode !== 'time') return true;
  var _getDateAndTimeFromDa = getDateAndTimeFromDateTime(unlockDateTime),
    date = _getDateAndTimeFromDa.date,
    time = _getDateAndTimeFromDa.time;
  var isPastUnlockTime = checkIsPastSectionUnlockDateTime(lockingMode, date, time, unlockTimezone);

  // We only show a time-locked section as locked in the preview mode if it wasn't already unlocked in the past
  return !isPastUnlockTime;
}